var _style, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 695.9 402.2",
    style: {
      enableBackground: "new 0 0 695.9 402.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#244AA5;}\n\t.st1{fill:url(#Trazado_7002_00000023254299348685790030000012766962134052673449_);}\n\t.st2{fill:url(#Trazado_7003_00000125573788130625985470000004640062320752111017_);}\n\t.st3{fill:url(#Trazado_7005_00000156583309929569615570000006948484664855561658_);}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 695.9,
    height: 402.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1320",
    transform: "translate(-4730.89 -5017.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1316",
    transform: "translate(5024.593 5017.099)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_7002_00000118367217509576671620000007579783953758164154_",
    gradientUnits: "userSpaceOnUse",
    x1: -456.2967,
    y1: 585.0468,
    x2: -455.2967,
    y2: 585.0468,
    gradientTransform: "matrix(401.5317 0 0 -401.5317 183218.0469 235116.2188)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    style: {
      stopColor: "#211D0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    style: {
      stopColor: "#41371A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    style: {
      stopColor: "#725C2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    style: {
      stopColor: "#9F813F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    style: {
      stopColor: "#D0A650"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    style: {
      stopColor: "#D0A650"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    style: {
      stopColor: "#D0A650"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7002",
    style: {
      fill: "url(#Trazado_7002_00000118367217509576671620000007579783953758164154_)"
    },
    d: "M201.1,402.2 C90.2,402.1,0.4,312.1,0.4,201.3C0.5,90.4,90.5,0.6,201.3,0.6C312.2,0.7,402,90.6,402,201.5c-0.1,80.6-48.3,153.4-122.6,184.8 C254.6,396.8,228,402.2,201.1,402.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1317",
    transform: "translate(4877.742 5017.099)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_7003_00000031202991826262022680000017450463259271898011_",
    gradientUnits: "userSpaceOnUse",
    x1: -309.4461,
    y1: 585.0468,
    x2: -308.4461,
    y2: 585.0468,
    gradientTransform: "matrix(401.5278 0 0 -401.5278 124251.6719 235113.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    style: {
      stopColor: "#211D0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    style: {
      stopColor: "#41371A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    style: {
      stopColor: "#725C2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    style: {
      stopColor: "#9F813F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    style: {
      stopColor: "#D0A650"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    style: {
      stopColor: "#D0A650"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    style: {
      stopColor: "#D0A650"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7003",
    style: {
      fill: "url(#Trazado_7003_00000031202991826262022680000017450463259271898011_)"
    },
    d: "M201.1,402.2 C90.2,402.1,0.4,312.1,0.4,201.3S90.5,0.6,201.3,0.6C312.2,0.7,402,90.6,402,201.5c-0.1,80.6-48.3,153.4-122.6,184.8 C254.6,396.8,228,402.2,201.1,402.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1319",
    transform: "translate(4730.89 5017.099)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trazado_7005_00000161616927016884637430000013118365889322541986_",
    gradientUnits: "userSpaceOnUse",
    x1: -162.5941,
    y1: 585.0468,
    x2: -161.5941,
    y2: 585.0468,
    gradientTransform: "matrix(401.5278 0 0 -401.5278 65286.4805 235113.9375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.115,
    style: {
      stopColor: "#211D0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425,
    style: {
      stopColor: "#41371A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    style: {
      stopColor: "#725C2E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791,
    style: {
      stopColor: "#9F813F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    style: {
      stopColor: "#D0A650"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    style: {
      stopColor: "#D0A650"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989,
    style: {
      stopColor: "#D0A650"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7005",
    style: {
      fill: "url(#Trazado_7005_00000161616927016884637430000013118365889322541986_)"
    },
    d: "M201.1,402.2 C90.2,402.1,0.4,312.1,0.4,201.3S90.5,0.6,201.3,0.6C312.2,0.7,402,90.6,402,201.5c-0.1,80.6-48.3,153.4-122.6,184.8 C254.6,396.8,228,402.2,201.1,402.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/login-background.b7e93e4e2d4c5e2b022fe9a38dd41a3b.svg";
export { ForwardRef as ReactComponent };